import type { CSSProperties } from 'react'
import { useAssetPageContext } from './Context'
import { useConfirmDialog, useError } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'

type DeleteAssetButtonProps = {
  _id: string
  style?: CSSProperties
}

export const DeleteAssetButton = ({ _id, style = {} }: DeleteAssetButtonProps) => {
  const { canEdit, onDeleteAsset } = useAssetPageContext()

  const { onError } = useError()

  const { confirm } = useConfirmDialog({
    text: `Are you sure you remove this item?`,
    title: 'Remove asset item?',
    buttons: { confirm: { text: 'Yes, remove it!' } },
  })

  const handleDeleteAsset = async () => {
    try {
      await confirm(async () => {
        // Use the deleteAsset mutation which removes by asset ID
        await onDeleteAsset(_id)
      })
    } catch (e) {
      onError(e)
    }
  }

  return (
    <BusyButton
      icon={'trash'}
      variant={'danger'}
      onClick={handleDeleteAsset}
      disabled={!canEdit}
      disabledReason={canEdit ? undefined : 'You do not have permission to remove this asset.'}
      style={style}
      bsSize={'sm'}
    />
  )
}
